<template>
  <img class="watch-status-badge" :src="badgeSrc" :alt="badgeAlt" />
</template>

<script>
import dgk from '@/assets/image/dgk.png'
import ygk from '@/assets/image/ygk.png'
import ywc from '@/assets/image/ywc.png'

const TEXT_STATUS_MAP = {
  待观看: dgk,
  未观看: dgk,
  已观看: ygk,
  观看中: ygk,
  已完成: ywc
}

const NUMERIC_STATUS_MAP = {
  '0': '待观看',
  '1': '已观看',
  '2': '已完成'
}

export default {
  name: 'WatchStatusBadge',
  props: {
    status: {
      type: [String, Number],
      default: '待观看'
    }
  },
  computed: {
    normalizedStatus() {
      const value = String(this.status == null ? '' : this.status).trim()
      if (!value) return '待观看'
      if (NUMERIC_STATUS_MAP[value]) return NUMERIC_STATUS_MAP[value]
      if (value.includes('完成')) return '已完成'
      if (value.includes('观看')) {
        return value.includes('待') || value.includes('未') ? '待观看' : '已观看'
      }
      return '待观看'
    },
    badgeSrc() {
      return TEXT_STATUS_MAP[this.normalizedStatus] || dgk
    },
    badgeAlt() {
      return this.normalizedStatus
    }
  }
}
</script>

<style scoped>
.watch-status-badge {
  display: block;
  width: 72px;
  height: auto;
  pointer-events: none;
  user-select: none;
}

@media (max-width: 480px) {
  .watch-status-badge {
    width: 64px;
  }
}
</style>
